import UserNewsTipsTable from './UserNewsTipsTable'
export default UserNewsTipsTable
